import * as React from 'react';
import { Button, Dropdown, Menu } from 'antd';

import { ZuluIcon } from 'src/app/shared/icon';

export enum ContextualMenuItemType {
	Normal = 0,
	Divider = 1,
	Header = 2,
	Options = 3,
}

export interface CommandItem {
	key: string;
	name: React.ReactNode;
	itemType?: ContextualMenuItemType;
	icon?: string;
	disabled?: boolean;
	onClick?: () => void;
	type?: 'primary' | 'danger';
	options?: { label: string; value: any; icon?: string; selected: boolean }[];
}

interface CommandProps {
	mode: ControlMode;
	items: CommandItem[];
	farItems?: (CommandItem | Button)[];
	divider?: any;
}

export class CommandBar extends React.Component<CommandProps, any> {

	public render() {
		const { items, farItems } = this.props;

		let buttons: any[] = [];
		if (items) {
			buttons = this.renderItems(items);
		}
		let farButtons: any[] = [];
		if (farItems) {
			farButtons = this.renderItems(farItems);
		}

		return (
			<React.Fragment>
				<Button.Group>{buttons}</Button.Group>
				{farButtons.length > 0 && <Button.Group style={{ float: "right" }}>{farButtons}</Button.Group>}
			</React.Fragment>
		);
	}

	private renderItems(items: (CommandItem | Button)[]): Button[] {
		let buttons: any[] = [];
		for (const item of items) {
			if (item instanceof Button || (item as any).type && (item as any).type.name == "Button") {// In runtime, instanceof don't work
				buttons.push(item);
			} else {
				let icon = item.icon && item.icon.search("^icon-") !== -1
					? <ZuluIcon type={item.icon} />
					: undefined;
				switch (item.itemType) {
					case ContextualMenuItemType.Divider:
						buttons.push((this.props.divider));
						break;
					case ContextualMenuItemType.Header:
						buttons.push(
							<Button key={item.key}
								type={item.type}
								icon={icon ? undefined : item.icon}
								disabled={true}>{icon}{item.name}</Button>
						);
						break;
					case ContextualMenuItemType.Options:
						if (item.options == null) {
							return null;
						}
						const menu = (
							<Menu onClick={item.onClick} selectedKeys={item.options.filter(e => e.selected).map(e => e.value.toString())}>
								{item.options.map(e => <Menu.Item key={e.value}><ZuluIcon type={e.icon} />{e.label}</Menu.Item>)}
							</Menu>
						);
						buttons.push(
							<Dropdown overlay={menu} key={item.key} className="top-1">
								<Button>
									{item.name} <ZuluIcon type="down" />
								</Button>
							</Dropdown>
						);
						break;
					default:
						buttons.push(
							<Button key={item.key}
								icon={icon ? undefined : item.icon}
								disabled={item.disabled || this.props.mode == "display"}
								type={item.type}
								onClick={item.onClick}>{icon}{item.name}</Button>
						);
						break;
				}
			}
		}
		return buttons;
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/command-bar.tsx